
    import './styles.scoped.css';
    export default {
  "icon": "awsui_icon_h11ix_swv0j_98",
  "icon-flex-height": "awsui_icon-flex-height_h11ix_swv0j_104",
  "size-small": "awsui_size-small_h11ix_swv0j_129",
  "size-small-mapped-height": "awsui_size-small-mapped-height_h11ix_swv0j_133",
  "size-normal": "awsui_size-normal_h11ix_swv0j_148",
  "size-normal-mapped-height": "awsui_size-normal-mapped-height_h11ix_swv0j_152",
  "size-medium": "awsui_size-medium_h11ix_swv0j_167",
  "size-medium-mapped-height": "awsui_size-medium-mapped-height_h11ix_swv0j_171",
  "size-big": "awsui_size-big_h11ix_swv0j_186",
  "size-big-mapped-height": "awsui_size-big-mapped-height_h11ix_swv0j_190",
  "size-large": "awsui_size-large_h11ix_swv0j_205",
  "size-large-mapped-height": "awsui_size-large-mapped-height_h11ix_swv0j_209",
  "variant-normal": "awsui_variant-normal_h11ix_swv0j_224",
  "variant-disabled": "awsui_variant-disabled_h11ix_swv0j_227",
  "variant-inverted": "awsui_variant-inverted_h11ix_swv0j_230",
  "variant-subtle": "awsui_variant-subtle_h11ix_swv0j_233",
  "variant-warning": "awsui_variant-warning_h11ix_swv0j_236",
  "variant-error": "awsui_variant-error_h11ix_swv0j_239",
  "variant-success": "awsui_variant-success_h11ix_swv0j_242",
  "variant-link": "awsui_variant-link_h11ix_swv0j_245",
  "badge": "awsui_badge_h11ix_swv0j_249"
};
  